import { useRosters } from './useRosters';
import { useAppSelector } from '../slices/commonSelectors';
import { selectUser, selectGroupGuid } from '../slices/commonSelectors';
import { GROUP_ADMIN } from 'constants/group';

export default function useIsOrgAdmin(): boolean {
  const user = useAppSelector(selectUser);
  const groupGuid = useAppSelector(selectGroupGuid);
  const { data: rosters, isLoading } = useRosters([groupGuid]);

  if (!rosters || !user.user_guid || !groupGuid || isLoading) {
    return false;
  }

  const userRoster = rosters.find(
    (r) => r.user_guid === user.user_guid && r.group_guid === groupGuid
  );

  return (
    userRoster?.role_assignments?.some((ra) => ra.name === GROUP_ADMIN) || false
  );
}
